import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalFichaCuentaComponent } from 'src/app/components/administrador/components/dialogs/modal-ficha-cuenta/modal-ficha-cuenta.component';
import { CuentasJardinModel, CuentasModel, ResponseCuentasJardinPaginationModel, ResponseCuentasModel, ResponseOtrasCuentasModel } from 'src/app/model/Cuentas.model';
import { apiService } from 'src/app/service/api.service';
import { environment } from 'src/environments/environment';
import { CapacitacionComponent } from '../../capacitacion.component';

@Component({
  selector: 'app-capacitacion-inicio',
  templateUrl: './capacitacion-inicio.component.html',
  styleUrls: ['./capacitacion-inicio.component.css']
})
export class CapacitacionInicioComponent implements OnInit {
  displayedColumns=[];
  filterValues = {};
  filterSelectObj = [];
  tipoCampos = [];
  arrayComunas = [];
  regiones = [];
  programas = [];
  dataSource: MatTableDataSource<CuentasJardinModel>;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  pageEvent: PageEvent;
  pageIndex:number;
  length:number;
  getSelect = false;
  apiEndpoint = environment.apiEndpoint;
  columnNames = [
    { id: 'region', value: 'region' }, 
    { id: 'comuna', value: 'comuna' }, 
    { id: 'programa', value: 'programa' }, 
    { id: 'codigo', value: 'codigo' }, 
    { id: 'nombre', value: 'nombre' }, 
    { id: 'induccion', value: 'induccion' }
  
  ];
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  infoSelectJardin: CuentasModel;
  constructor(
    private api: apiService,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }



  ngOnInit(): void {
    this.getSelectCuentas();
    this.palabraClave = "";
    this.idRegion = 0;
    this.idComuna = 0;
    this.idPrograma = 0;
    this.getServerData(); 
  }


  getSelectCuentas(){
    this.api.API_POST_getSelectCuentas().subscribe((response: ResponseCuentasModel) => {
      this.infoSelectJardin = response.payload
      this.regiones = this.infoSelectJardin.regiones;
      this.programas = this.infoSelectJardin.programas;
    },
    (err) => {
      console.log(err)
    })
  }

  
  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null );
  }


  public callData(event?:PageEvent){
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.spinner.show();
    this.api.API_POST_getCuentasJardinAdminConsolidado(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: ResponseCuentasJardinPaginationModel) => {
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<CuentasJardinModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      //this.pageSize = response.payload.pageSize;
      this.length = response.payload.total;
      setTimeout(() => {  
        this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }

  
  bloquear(row:CuentasJardinModel, tipo: string){
      this.spinner.show();
      this.api.API_POST_bloquearUsuario(row.id, tipo).subscribe((response: ResponseOtrasCuentasModel) => {
          this.spinner.hide();
      },
      (err) => {
        console.log(err)
        alert(err)
        this.spinner.hide();
      })
  } 

  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }
  

  verCuentaJardin(row:CuentasJardinModel){

    const dialogRef = this.dialog.open(ModalFichaCuentaComponent,{
      disableClose: true ,
      width: '50%',
      data: {idJardinPeriodo: row.id, dataSelects: this.infoSelectJardin}
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getServerData();
    });
  }

  crearCuentaJardin(){ 
    const dialogRef = this.dialog.open(ModalFichaCuentaComponent,{
      disableClose: true ,
      width: '50%',
      data: {idJardinPeriodo: 0, dataSelects: this.infoSelectJardin}
    });

    dialogRef.afterClosed().subscribe((result) => {
  
      if(result != null && result != ''){
        this.getServerData();
      } 
    });
  }

  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }

  editarCuentaJardin(row:CuentasJardinModel, position){ 
  
    const dialogRef = this.dialog.open(ModalFichaCuentaComponent,{
      disableClose: true ,
      width: '50%',
      data: {idJardinPeriodo: row.id, dataSelects: this.infoSelectJardin}
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getServerData();
    });
    
  }

  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }
}
